import canadianPostalCodes from '../../utils/canadianPostalCodes';
import { fieldPostalCodeVul } from '../../utils/constant';

/**
 * Whether the service postal code's FSA (first 3 characters) is in the
 * serviceable list — a 1:1 port of formStepVulcan's `getPostalCodeFromFormFields`,
 * which read the legacy `formFields` bag and was recomputed on every render of
 * `renderFormFields`, so it tracked live edits.
 *
 * Reading engine `values` keeps that liveness: postal-code edits now land in
 * engine state, so a legacy-bag-derived value would go stale after the first
 * render. Equipment consumes this as `postalCodeMatches`, which gates the
 * `guardResponseWLN` fields.
 *
 * @param {Object.<string,*>} values  the engine's value bag
 * @returns {boolean}
 */
export const doesPostalCodeMatch = (values = {}) => {
  const postalCodeValue = values[fieldPostalCodeVul];
  if (!postalCodeValue) return false;
  const normalizedFSA = String(postalCodeValue)
    .toUpperCase()
    .trim()
    .replace(/\s+/g, '')
    .substring(0, 3);
  return canadianPostalCodes.some(
    code =>
      code
        .toUpperCase()
        .trim()
        .replace(/\s+/g, '') === normalizedFSA
  );
};

export default doesPostalCodeMatch;
